import { lazy, useCallback, useEffect } from "react"
import {
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom"

import 'react-toastify/dist/ReactToastify.css'

import AppRoutes from '@/config/app.routes'

import ToastPortal from "@/components/toast-portal/toast-portal"

import { useNavigation } from "@/providers/NavigationProvider"
import { useAuth } from "@/providers/AuthProvider"

//import useAppSetup from "@/utils/hooks/UseAppSetup"
import { ProtectedRoute } from "@/components/protected-route/protected-route"
import eventBus from "@/utils/EventBus"

// TODO: [Launch] Fix legacy js errors related to sass

const Oauth = lazy(() => import("./pages/oauth/oauth"))
const ConfirmAccount = lazy(() => import("./pages/confirm-account/confirm-account"))
const ErrorViewer = lazy(() => import("./pages/error-viewer/error-viewer"))

const MyAccount = lazy(() => import("./pages/my-account/my-account"))
const CreateAccount = lazy(() => import("./pages/create-account/create-account"))
//const LinkAccounts = lazy(() => import("./pages/link-accounts/link-accounts"))
const VerifyAccount = lazy(() => import("./pages/verify-account/verify-account"))
const Signin = lazy(() => import("./pages/signin/signin"))
const CashOut = lazy(() => import("./pages/cash-out/cash-out"))

const ForgotPassword = lazy(() => import("./pages/forgot-password/forgot-password"))
const Welcome = lazy(() => import("./pages/welcome/welcome"))

const App = () => {

  //useAppSetup()

  const { navigate } = useNavigation()
  const { logout } = useAuth()
  const { pathname, hash, key } = useLocation()
  const logOut = useCallback(() => {
    logout().then(() => {
      navigate(AppRoutes.HOME)
    })
  }, [navigate, logout])


  useEffect(() => {
    if (hash === "") {
      window.scrollTo(0, 0)
    } else {
      setTimeout(() => {
        const id = hash.replace("#", "")
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({
            block: "start",
            inline: "nearest",
            behavior: "smooth",
          })
        }
      }, 0)
    }
  }, [pathname, hash, key])

  useEffect(() => {
    const handleLogout = () => {
      logOut()
    }

    const logoutListener = eventBus.on("user:logout", handleLogout)

    return () => {
      eventBus.remove("user:logout", logoutListener)
    }
  }, [logOut])

  return <>
    <Routes>
      <Route path={AppRoutes.HOME} element={<ProtectedRoute><MyAccount /></ProtectedRoute>} />

      <Route path={AppRoutes.LOGIN} element={<Signin />} />
      <Route path={AppRoutes.FORGOT_PASSWORD} element={<ForgotPassword />} />
      {/* <Route path={AppRoutes.UNLOCK_ACCOUNT}  element={<CashOut />} /> */}
      {/* <Route path={AppRoutes.TERMS}           element={<CashOut />} /> */}
      {/* <Route path={AppRoutes.PRIVACY}         element={<CashOut />} /> */}

      <Route path={AppRoutes.CREATE_ACCOUNT}  element={<CreateAccount nextStep={AppRoutes.VERIFY_ACCOUNT} />} />
      <Route path={AppRoutes.VERIFY_ACCOUNT}  element={<ProtectedRoute><VerifyAccount /></ProtectedRoute>} />
      <Route path={AppRoutes.CONFIRM_ACCOUNT} element={<ProtectedRoute><ConfirmAccount nextStep={AppRoutes.LINK_ACCOUNTS} /></ProtectedRoute>} />
      {/* <Route path={AppRoutes.LINK_ACCOUNTS} element={<ProtectedRoute><LinkAccounts nextStep={AppRoutes.WELCOME} /></ProtectedRoute>} /> */}
      <Route path={AppRoutes.WELCOME} element={<ProtectedRoute><Welcome nextStep={AppRoutes.MY_ACCOUNT} /></ProtectedRoute>} />

      <Route path={AppRoutes.MY_ACCOUNT} element={<ProtectedRoute><MyAccount /></ProtectedRoute>} />
      {/* <Route path={AppRoutes.HISTORY} element={<ProtectedRoute><History />ProtectedRoute>} /> */}
      {/* <Route path={AppRoutes.PROFILE} element={<ProtectedRoute><Profile />ProtectedRoute>} /> */}
      {/* <Route path={AppRoutes.REQSTS} element={<ProtectedRoute><Reqsts />ProtectedRoute>} /> */}
      {/* <Route path={AppRoutes.SETTINGS} element={<ProtectedRoute><Settings />ProtectedRoute>} /> */}

      <Route path={AppRoutes.CASH_OUT} element={<ProtectedRoute><CashOut /></ProtectedRoute>} />
      <Route path={AppRoutes.HISTORY}  element={<ProtectedRoute><CashOut /></ProtectedRoute>} />
      <Route path={AppRoutes.PROFILE}  element={<ProtectedRoute><CashOut /></ProtectedRoute>} />
      <Route path={AppRoutes.REQSTS}   element={<ProtectedRoute><CashOut /></ProtectedRoute>} />
      <Route path={AppRoutes.SETTINGS} element={<ProtectedRoute><CashOut /></ProtectedRoute>} />

      <Route path={AppRoutes.ERROR} element={<ErrorViewer />} />
      <Route path={AppRoutes.OAUTH} element={<Oauth />} />

      <Route path={AppRoutes.UNKNOWN} element={<Navigate to={AppRoutes.HOME} replace />} />
    </Routes>
    <ToastPortal />
  </>
}

export default App